import React from "react";
import clsx from 'clsx';
import { connect } from 'react-redux';
import Datetime from "react-datetime";
import DatePicker from 'react-date-picker';
import DateTimePicker from 'react-datetime-picker'

import compose from 'recompose/compose';
import { Redirect, withRouter } from 'react-router-dom';

import PropTypes from "prop-types";

import axios from 'axios'
import firebase, { db, storage, sendEmail, sendSMS } from "firebase/fbConfig.js"
import moment from 'moment'
import { v1 as uuidv1 } from 'uuid';

import Geocode from "react-geocode";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import { makeStyles } from '@material-ui/core/styles';
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from '@material-ui/lab/Alert';
import CircularProgress from '@material-ui/core/CircularProgress';


// @material-ui/icons
import Face from "@material-ui/icons/Face";
import Email from "@material-ui/icons/Email";
import Check from '@material-ui/icons/Check';


// @material-ui/lab
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';

// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import styles from "assets/jss/material-dashboard-pro-react/components/ActionSubmitFormStyle.jsx";
import ShipFullScreenMap from "../../views/Maps/ShipFullScreenMap";
import FormLabel from '@material-ui/core/FormLabel';
import FullScreenMap from "../../views/Maps/ShipFullScreenMap";

 
const useStyles = makeStyles((theme) => ({
    button: {
        maxWidth: '200px'
    },
    buttonProgress: {
        color: 'white',
        margin: '0 -16px 0 8px'
    },
    wrapper: {
        margin: theme.spacing(1),
        position: 'relative',
    },
}));

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const LoadButton = props => {
    const { children, isLoading, ...rest } = props;
    const classes = useStyles();
    return (
        <div className={classes.wrapper}>
            <Button
                className={classes.button}
                color='primary'
                disabled={isLoading}
                {...rest}
            >
                {children}
                {isLoading && (
                    <CircularProgress size={20} className={classes.buttonProgress} disableShrink />
                )}
            </Button>
        </div>
    );
}

const filter = createFilterOptions();

class Form extends React.Component {
    state = {
        comment: '',
        queryString: "",
        actionAssigned: false,
        assignedError: false,
        defaultLoaded: false,
        assigningAction: "",
        cardAnimaton: "cardHidden",
        messageSent: false,
        messageError: false,
        mapDataSaved: true
    }
    constructor(props) {
        super(props);
        // we use this to make the card to appear after the page has been rendered
        this.state = {
            cardAnimaton: "cardHidden",
            orderID: window.location.pathname.split('/')[2] ? window.location.pathname.split('/')[2] : window.location.search.split('&')[1].substring(6),
            shippingMode: '',
            pickUpServices: '',
            dropOffServices: '',
            services: '',
            items: [],
            itemCount: 1,
            userSet: false,
            step5: true,
            item2: false,
            item3: false,
            matchingFlights: [],
            hideFlights: false,
            radius: 200,
            cargoAir: {},
            air: {},
            ground: {},
            ltl: {},
            autoLtl: {},
            openChats: []
        };
    }
    componentDidMount() {
        // we add a hidden class to the card and after 700 ms we delete it and the transition appears
        this.timeOutFunction = setTimeout(
            function () {
                this.setState({ cardAnimaton: "" });
            }.bind(this),
            700
        );
    }
    componentWillUnmount() {
        clearTimeout(this.timeOutFunction);
        this.timeOutFunction = null;
    }
    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value,
        })
    }

    handleArrChange = (e, arr) => {
        const array = this.state.orderData[arr];
        array[e.target.id] = e.target.value;
        this.setState({
            [arr]: array
        })
    }

    handleItemChange = (e, i) => {
        const orderData = this.state.orderData;
        orderData.items[i][e.target.id || e.target.name] = e.target.value;
        console.log(orderData, e.target.id, e.target.value);
        this.setState({ orderData: orderData });
    }

    handleItemSelectChange = (e, i) => {
        const orderData = this.state.orderData;
        orderData.items[i][e.target.name] = e.target.value

        this.setState({ orderData: orderData });
    }

    handleDateChange = (date, obj) => {
        if (date) {
            const bucket = this.state.orderData[obj];
            bucket['date'] = date;
            this.setState({
                [obj]: bucket
            })
        }
    }

    handleDateTimeChange = (date, obj) => {
        let bucket = this.state[obj];
        console.log(bucket)
        bucket['quoteETA'] = date;
        this.setState({
            [obj]: bucket
        })
    }

    handleToggleItemServices(value, iterator) {
        var orderData = this.state.orderData;
        value = value.includes(" ") ? value.split(" ").join("") : value;
        orderData.items[iterator][`is${value}`] == true ? delete orderData.items[iterator][`is${value}`] : orderData.items[iterator][`is${value}`] = true;
        this.setState({ orderData: orderData });
    }

    handlePickUpDateChange = (pickUpDate) => {
        //console.log(pickUpDate._d)
        if (pickUpDate) {
            this.setState(() => ({ pickUpDate: pickUpDate, pickUpAPI: moment(pickUpDate).format('YYYY-MM-DD') }))
        }
    }

    handleDropOffDateChange = (dropOffDate) => {
        //console.log(dropOffDate)
        if (dropOffDate) {
            this.setState(() => ({ dropOffDate: dropOffDate }))
        }
    }

    // only make future selectable  
    valid = (current) => {
        return current.isAfter(Datetime.moment().subtract(1, 'day'));
    };

    handleSelectChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
            pickUpDriverContactLoaded: false
        })
        // console.log(this.state)
    }

    handleSelectChangeObj = (e, obj) => {
        const bucket = this.state.orderData[obj];
        bucket[e.target.name] = e.target.value;
        this.setState({
            [obj]: bucket
        });
    }

    handleSelectChangeStateObj = (e, obj) => {
        let orderData = this.state.orderData;
        orderData[obj][e.target.name] = e.target.value;
        this.setState({
            orderData: orderData
        });
    }

    handleTogglePickupServices(value) {
        const { pickUpServices } = this.state;
        const currentIndex = pickUpServices.indexOf(value);
        const newPickUpServices = [...pickUpServices];

        if (currentIndex === -1) {
            newPickUpServices.push(value);
        } else {
            newPickUpServices.splice(currentIndex, 1);
        }

        this.setState({
            pickUpServices: newPickUpServices
        });
    }

    handleToggleDropOffServices(value) {
        const { dropOffServices } = this.state;
        const currentIndex = dropOffServices.indexOf(value);
        const newDropOffServices = [...dropOffServices];

        if (currentIndex === -1) {
            newDropOffServices.push(value);
        } else {
            newDropOffServices.splice(currentIndex, 1);
        }

        this.setState({
            dropOffServices: newDropOffServices
        });
    }

    handleToggleServices(value, obj) {
        const orderData = this.state.orderData;
        const { services } = orderData[obj];
        const index = services.indexOf(value);

        if (index !== -1) {
            services.splice(index, 1)
        } else {
            services.push(value)
        }

        orderData[obj].services = services;

        this.setState({ orderData: orderData });
    }

    handleClickOpen = (modal) => {
        var x = [];
        x[modal] = true;
        this.setState({
            ...x,
        });
    }

    handleClose = (modal) => {
        var x = [];
        x[modal] = false;
        this.setState(x);
    }

    closeSnack = (snack) => {
        this.setState({
            [snack]: false
        })
    }

    grabData = (key) => {

        const checkObj = () => {
            const checkArray = () => {
                if ((Array.isArray(this.state[key]) && this.state[key].length) || !this.state.orderData[key] || (this.state[key] && this.state[key].length && (this.state.orderData[key] && !this.state.orderData[key].length))) {
                    return this.state[key];
                } else {
                    return this.state.orderData[key];
                }
            }

            if (Array.isArray(this.state[key]) || Array.isArray(this.state.orderData[key])) {
                return checkArray();
            }

            if (typeof this.state[key] === 'object' && this.state[key] !== null && Object.keys(this.state[key]).length) {
                return this.state[key]
            } else if (this.state.orderData[key] && typeof this.state.orderData[key] === 'object' && Object.keys(this.state.orderData[key]).length) {
                return this.state.orderData[key]
            } else {
                return null
            }
        }

        const checkOther = () => {
            if (this.state[key]) {
                return this.state[key];
            } else if (this.state.orderData[key]) {
                return this.state.orderData[key];
            } else {
                return null
            }
        }

        if ((typeof this.state[key] === 'object' && this.state[key] !== null) || (typeof this.state.orderData[key] === 'object' && this.state.orderData[key] !== null)) {
            return checkObj();
        } else {
            return checkOther();
        }
    }

    uploadImage = (refString, pic) => {
        console.log("Uploading image");
        return new Promise((resolve, reject) => {
            // create storage ref
            var storageRef = storage.ref(refString);
            // upload pic
            var uploadTask = storageRef.put(pic);
            // update progress bar
            uploadTask.on('state_changed', (snapshot) => {
                // Observe state change events such as progress, pause, and 
                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                var Progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                this.setState({ uploadProgress: 'Progress is ' + Progress + '% done' });

                switch (snapshot.state) {
                    case firebase.storage.TaskState.PAUSED: // or 'paused'
                        this.setState({ uploadProgress: ' Upload is paused' });
                        break;
                    case firebase.storage.TaskState.RUNNING: // or 'running'
                        this.setState({ uploadProgress: 'Upload is running' });
                        break;
                }

            }, (error) => {
                // Handle unsuccessful uploads
                console.log(error)
            }, () => {
                // Handle successful uploads on complete
                // For instance, get the download URL: https://firebasestorage.googleapis.com/...
                uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                    resolve(downloadURL)
                });
            })
        })
    }

    // groupOrder = () => {
    //     let data = db.collection("haney-orders")
    //     .get().then((snapshot) => {
    //         //console.log(snapshot)
    //         const data = []
    //         // Parse data into array like in firebase.js
    //         snapshot.forEach(async (doc) => {
    //             var docData = doc.data()
    //             var docObj = {
    //                 name: docData.name,
    //                 id: doc.id,
    //             }
    //             data.push(docObj);
    //             console.log(doc.id)
    //             await db.collection('haney-groups').doc("0GaWMBdpfwObZwfLePWJ").collection("orders").doc(doc.id).set({
    //                 id: doc.id
    //             }, { merge: true })
    //         })
    //         return (data)
    //     }, (error) => {
    //         console.log('error fetching data: ', error)
    //     }).then(data => {
    //         data
    //         this.setState({
    //             vendorsData: data,
    //             vendorsDataLoaded: true,
    //         })
    //     })


        // // update firestore document with PENDING and comment
        // db.collection("haney-orders").doc(this.state.orderData.id).set({
        //     status: "canceled",
        //     canceledAt: new Date()
        // }, { merge: true }).then(() => {
        //     db.collection("TEST-users").doc(this.state.orderData.uid).collection("orders").doc(this.state.orderData.id).set({
        //         status: "canceled",
        //         canceledAt: new Date()
        //     }, { merge: true }).then(async () => {
        //         // console.log(this.state.pickUpDriverContact.email)
        //         //const email = this.props.user.email

        //         // let subject = `Your order has been quoted!`
        //         // let html = `<p>Hello </p>`
        //         // html += `<p>Order #: ${this.state.orderData.id}</p><a href=https://haney-freightways-customer.web.app/quote/${this.state.orderData.id}>Go to Quote</a>`
        //         // // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
        //         // const emails = [this.state.orderUserData.email]
        //         // const attatchment = true;
        //         // const emailReturn = await sendEmail({
        //         //     emails,
        //         //     subject,
        //         //     html,
        //         //     attatchment
        //         // })

        //     }).then(() => {
        //         // window.location.reload()
        //     })
        // })
    // }


    cancelOrder = () => {
        // update firestore document with PENDING and comment
        db.collection("haney-orders").doc(this.state.orderData.id).set({
            status: "canceled",
            canceledAt: new Date()
        }, { merge: true }).then(() => {
            db.collection("TEST-users").doc(this.state.orderData.uid).collection("orders").doc(this.state.orderData.id).set({
                status: "canceled",
                canceledAt: new Date()
            }, { merge: true }).then(async () => {
                // console.log(this.state.pickUpDriverContact.email)
                //const email = this.props.user.email

                // let subject = `Your order has been quoted!`
                // let html = `<p>Hello </p>`
                // html += `<p>Order #: ${this.state.orderData.id}</p><a href=https://haney-freightways-customer.web.app/quote/${this.state.orderData.id}>Go to Quote</a>`
                // // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
                // const emails = [this.state.orderUserData.email]
                // const attatchment = true;
                // const emailReturn = await sendEmail({
                //     emails,
                //     subject,
                //     html,
                //     attatchment
                // })

            }).then(() => {
                window.location.reload()
            })
        })
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const associations = [{ key: 'air', label: 'Air' }, { key: 'cargoAir', label: 'Next Day Air' }, { key: 'ground', label: 'Ground' }, { key: 'ltl', label: 'Additional Options' }, { key: 'autoLtl', label: 'LTL' }];
        const errors = [];

        this.setState({ quoteSending: true })

        if (!this.state.airQuote && !this.state.cargoAirQuote && !this.state.groundQuote && !this.state.ltlQuote && !this.state.autoLtlQuote) {
            this.setState({ errorSnackMessage: `Please fill out a quote`, errorSnack: true, quoteSending: false });
            return;
        }


        for (let i = 0; i < associations.length; i++) {
            const quoteObject = this.grabData(associations[i].key);
            const quote = this.grabData(`${associations[i].key}Quote`);
            if (quote && !(quoteObject && quoteObject.quoteETA)) {
                errors.push(`ETA for ${associations[i].label}`)
            }
        }

        if (errors.length) {
            this.setState({ errorSnackMessage: `Please fill out the following: ${errors.join(', ')}`, errorSnack: true, quoteSending: false });
            return;
        }



        // update firestore document with PENDING and comment
        db.collection("haney-orders").doc(this.state.orderData.id).set({
            airQuote: this.state.airQuote ? this.state.airQuote : (this.state.orderData.airQuote ? this.state.orderData.airQuote : null),
            cargoAirQuote: this.state.cargoAirQuote ? this.state.cargoAirQuote : (this.state.orderData.cargoAirQuote ? this.state.orderData.cargoAirQuote : null),
            subDeliveryType: this.state.subDeliveryType ? this.state.subDeliveryType : (this.state.orderData.subDeliveryType ? this.state.orderData.subDeliveryType : null),
            groundQuote: this.state.groundQuote ? this.state.groundQuote : (this.state.orderData.groundQuote ? this.state.orderData.groundQuote : null),
            ltlQuote: this.state.ltlQuote ? this.state.ltlQuote : (this.state.orderData.ltlQuote ? this.state.orderData.ltlQuote : null),
            autoLtlQuote: this.state.autoLtlQuote ? this.state.autoLtlQuote : (this.state.orderData.autoLtlQuote ? this.state.orderData.autoLtlQuote : null),
            air: this.state.air.quoteETA ? this.state.air : (this.state.orderData.air ? this.state.orderData.air : null),
            cargoAir: this.state.cargoAir.quoteETA ? this.state.cargoAir : (this.state.orderData.cargoAir ? this.state.orderData.cargoAir : null),
            ground: this.state.ground.quoteETA ? this.state.ground : (this.state.orderData.ground ? this.state.orderData.ground : null),
            ltl: this.state.ltl.quoteETA ? this.state.ltl : (this.state.orderData.ltl ? this.state.orderData.ltl : null),
            autoLtl: this.state.autoLtl.quoteETA ? this.state.autoLtl : (this.state.orderData.autoLtl ? this.state.orderData.autoLtl : null),
            userQuoteUID: this.props.authUser.uid,
            userQuoteEmail: this.props.user.email,
            dispatcherID: this.props.authUser.uid,
            flight: this.state.flight ? this.state.flight : null,
            status: "quoted",
            quotedAt: new Date()
        }, { merge: true }).then(() => {
            db.collection("TEST-users").doc(this.state.orderData.uid).collection("orders").doc(this.state.orderData.id).set({
                airQuote: this.state.airQuote ? this.state.airQuote : (this.state.orderData.airQuote ? this.state.orderData.airQuote : null),
                cargoAirQuote: this.state.cargoAirQuote ? this.state.cargoAirQuote : (this.state.orderData.cargoAirQuote ? this.state.orderData.cargoAirQuote : null),
                subDeliveryType: this.state.subDeliveryType ? this.state.subDeliveryType : (this.state.orderData.subDeliveryType ? this.state.orderData.subDeliveryType : null),
                groundQuote: this.state.groundQuote ? this.state.groundQuote : (this.state.orderData.groundQuote ? this.state.orderData.groundQuote : null),
                ltlQuote: this.state.ltlQuote ? this.state.ltlQuote : (this.state.orderData.ltlQuote ? this.state.orderData.ltlQuote : null),
                autoLtlQuote: this.state.autoLtlQuote ? this.state.autoLtlQuote : (this.state.orderData.autoLtlQuote ? this.state.orderData.autoLtlQuote : null),
                air: this.state.air ? this.state.air : (this.state.orderData.air ? this.state.orderData.air : null),
                cargoAir: this.state.cargoAir ? this.state.cargoAir : (this.state.orderData.cargoAir ? this.state.orderData.cargoAir : null),
                ground: this.state.ground ? this.state.ground : (this.state.orderData.ground ? this.state.orderData.ground : null),
                ltl: this.state.ltl ? this.state.ltl : (this.state.orderData.ltl ? this.state.orderData.ltl : null),
                autoLtl: this.state.autoLtl ? this.state.autoLtl : (this.state.orderData.autoLtl ? this.state.orderData.autoLtl : null),
                userQuoteUID: this.props.authUser.uid,
                userQuoteEmail: this.props.user.email,
                dispatcherID: this.props.authUser.uid,
                flight: this.state.flight ? this.state.flight : null,
                status: "quoted",
                quotedAt: new Date()
            }, { merge: true }).then(async () => {
                // console.log(this.state.pickUpDriverContact.email)
                //const email = this.props.user.email

                let subject = `Your order has been quoted!`
                let html = `<p>Hello </p>`
                html += `<p>Order #: ${this.state.orderData.freightBillNumber}</p><a href=https://cargo-rx.web.app/quote/${this.state.orderData.id}>Go to Quote</a>`
                // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
                let billingParty = this.state.orderData.billingParty
                let userEmail = ""
                if (billingParty == "Shipper") {
                    userEmail = (this.state.orderData.origin.email ? this.state.orderData.origin.email : this.state.orderUserData.email)
                } else if (billingParty == "Consignee") {
                    userEmail = (this.state.orderData.destination.email ? this.state.orderData.destination.email : this.state.orderUserData.email)
                } else if (billingParty == "Third Party") {
                    userEmail = (this.state.orderData.thirdParty.email ? this.state.orderData.thirdParty.email : this.state.orderUserData.email)
                } else {
                    userEmail = this.state.orderUserData.email
                }

                const emails = [userEmail]
                const attatchment = true;
                const emailReturn = await sendEmail({
                    emails,
                    subject,
                    html,
                    attatchment
                })

            }).then(() => {
                console.log(this.state.orderData)
                db.collection("notifications").add({
                    description: `#${this.state.orderData.freightBillNumber} has been quoted.`,
                    customerID: this.props.authUser.uid,
                    orderID: this.state.orderData.id,
                    freightBillNumber: this.state.orderData.freightBillNumber,
                    notificationType: "orderQuoted",
                    timestamp: new Date()
                }).then(() => {
                    // console.log(this.state.pickUpDriverContact.email)
                    //const email = this.props.user.email

                    // let subject = `Customer has booked shipment!`
                    // let html = `<p>Hello </p>`
                    // html += `<p>Orders #: ${this.state.orderData.id}</p><a href="https://haney-freightways-customer.web.app/orders/">Go to Orders</a>`
                    // // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
                    // const emails = [this.state.orderUserData.email]
                    // const attatchment = true;
                    // const emailReturn = await sendEmail({
                    //     emails,
                    //     subject,
                    //     html,
                    //     attatchment
                    // })

                }).then(() => {
                    window.location.reload()
                })
            })
        })
    }

    saveAsQuote = () => {
        // update firestore document with PENDING and comment
        console.log("saving quote")
        db.collection("TEST-quotes").add({
            uid: this.state.uid ? this.state.uid : null,
            role: this.state.role ? this.state.role : null,
            status: "pending",
            originBusinessName: this.state.originBusinessName ? this.state.originBusinessName : null,
            originContactName: this.state.originContactName ? this.state.originContactName : null,
            originContactEmail: this.state.originContactEmail ? this.state.originContactEmail : null,
            originContactPhone: this.state.originContactPhone ? this.state.originContactPhone : null,
            originOpenTime: this.state.originOpenTime ? this.state.originOpenTime : null,
            originCloseTime: this.state.originCloseTime ? this.state.originCloseTime : null,
            originStartTimeWindow: this.state.originStartTimeWindow ? this.state.originStartTimeWindow : null,
            originEndTimeWindow: this.state.originEndTimeWindow ? this.state.originEndTimeWindow : null,
            originAddress: this.state.originAddress ? this.state.originAddress : null,
            originCity: this.state.originCity ? this.state.originCity : null,
            originState: this.state.originState ? this.state.originState : null,
            originZip: this.state.originZip ? this.state.originZip : null,
            originType: this.state.originType ? this.state.originType : null,
            pickUpDate: this.state.pickUpDate ? this.state.pickUpDate : null,
            pickUpServices: this.state.pickUpServices ? this.state.pickUpServices : null,
            destinationBusinessName: this.state.destinationBusinessName ? this.state.destinationBusinessName : null,
            destinationContactName: this.state.destinationContactName ? this.state.destinationContactName : null,
            destinationContactEmail: this.state.destinationContactEmail ? this.state.destinationContactEmail : null,
            destinationContactPhone: this.state.destinationContactPhone ? this.state.destinationContactPhone : null,
            destinationOpenTime: this.state.destinationOpenTime ? this.state.destinationOpenTime : null,
            destinationCloseTime: this.state.destinationCloseTime ? this.state.destinationCloseTime : null,
            destinationStartTimeWindow: this.state.destinationStartTimeWindow ? this.state.destinationStartTimeWindow : null,
            destinationEndTimeWindow: this.state.destinationEndTimeWindow ? this.state.destinationEndTimeWindow : null,
            destinationAddress: this.state.destinationAddress ? this.state.destinationAddress : null,
            destinationCity: this.state.destinationCity ? this.state.destinationCity : null,
            destinationState: this.state.destinationState ? this.state.destinationState : null,
            destinationZip: this.state.destinationZip ? this.state.destinationZip : null,
            destinationType: this.state.destinationType ? this.state.destinationType : null,
            dropOffDate: this.state.dropOffDate ? this.state.dropOffDate : null,
            dropOffServices: this.state.dropOffServices ? this.state.dropOffServices : null,
            services: this.state.services ? this.state.services : null,
            unNumber: this.state.unNumber ? this.state.unNumber : null,
            properShippingName: this.state.properShippingName ? this.state.properShippingName : null,
            packaging: this.state.packaging ? this.state.packaging : null,
            quantity: this.state.quantity ? this.state.quantity : null,
            weight: this.state.weight ? this.state.weight : null,
            height: this.state.height ? this.state.height : null,
            width: this.state.width ? this.state.width : null,
            depth: this.state.depth ? this.state.depth : null,
            class: this.state.class ? this.state.class : null,
            deliveryType: this.state.deliveryType ? this.state.deliveryType : null,
            flightNumber: this.state.flightNumber ? this.state.flightNumber : null,
            page: window.location.pathname,
            updatedAt: new Date()
        }).then((docRef) => {
            db.collection("TEST-users").doc(this.state.uid).collection("quotes").doc(docRef.id).set({
                uid: this.state.uid ? this.state.uid : null,
                role: this.state.role ? this.state.role : null,
                status: "pending",
                originBusinessName: this.state.originBusinessName ? this.state.originBusinessName : null,
                originContactName: this.state.originContactName ? this.state.originContactName : null,
                originContactEmail: this.state.originContactEmail ? this.state.originContactEmail : null,
                originContactPhone: this.state.originContactPhone ? this.state.originContactPhone : null,
                originOpenTime: this.state.originOpenTime ? this.state.originOpenTime : null,
                originCloseTime: this.state.originCloseTime ? this.state.originCloseTime : null,
                originStartTimeWindow: this.state.originStartTimeWindow ? this.state.originStartTimeWindow : null,
                originEndTimeWindow: this.state.originEndTimeWindow ? this.state.originEndTimeWindow : null,
                originAddress: this.state.originAddress ? this.state.originAddress : null,
                originCity: this.state.originCity ? this.state.originCity : null,
                originState: this.state.originState ? this.state.originState : null,
                originZip: this.state.originZip ? this.state.originZip : null,
                originType: this.state.originType ? this.state.originType : null,
                pickUpDate: this.state.pickUpDate ? this.state.pickUpDate : null,
                pickUpServices: this.state.pickUpServices ? this.state.pickUpServices : null,
                destinationBusinessName: this.state.destinationBusinessName ? this.state.destinationBusinessName : null,
                destinationContactName: this.state.destinationContactName ? this.state.destinationContactName : null,
                destinationContactEmail: this.state.destinationContactEmail ? this.state.destinationContactEmail : null,
                destinationContactPhone: this.state.destinationContactPhone ? this.state.destinationContactPhone : null,
                destinationOpenTime: this.state.destinationOpenTime ? this.state.destinationOpenTime : null,
                destinationCloseTime: this.state.destinationCloseTime ? this.state.destinationCloseTime : null,
                destinationStartTimeWindow: this.state.destinationStartTimeWindow ? this.state.destinationStartTimeWindow : null,
                destinationEndTimeWindow: this.state.destinationEndTimeWindow ? this.state.destinationEndTimeWindow : null,
                destinationAddress: this.state.destinationAddress ? this.state.destinationAddress : null,
                destinationCity: this.state.destinationCity ? this.state.destinationCity : null,
                destinationState: this.state.destinationState ? this.state.destinationState : null,
                destinationZip: this.state.destinationZip ? this.state.destinationZip : null,
                destinationType: this.state.destinationType ? this.state.destinationType : null,
                dropOffDate: this.state.dropOffDate ? this.state.dropOffDate : null,
                dropOffServices: this.state.dropOffServices ? this.state.dropOffServices : null,
                services: this.state.services ? this.state.services : null,
                unNumber: this.state.unNumber ? this.state.unNumber : null,
                properShippingName: this.state.properShippingName ? this.state.properShippingName : null,
                packaging: this.state.packaging ? this.state.packaging : null,
                quantity: this.state.quantity ? this.state.quantity : null,
                weight: this.state.weight ? this.state.weight : null,
                height: this.state.height ? this.state.height : null,
                width: this.state.width ? this.state.width : null,
                depth: this.state.depth ? this.state.depth : null,
                class: this.state.class ? this.state.class : null,
                deliveryType: this.state.deliveryType ? this.state.deliveryType : null,
                flightNumber: this.state.flightNumber ? this.state.flightNumber : null,
                page: window.location.pathname,
                updatedAt: new Date()
            }, { merge: true }).then(() => {
                this.props.history.push('/quotes')
            }).then(() => {
                window.location.reload()
            }).catch((err) => {
                console.log(`${err}`)
            })
        }).catch((err) => {
            console.log(`${err}`)
        })
    }


    resetRequest = () => {
        window.location.reload();
    }

    setUser = (user) => {
        this.setState({
            uid: user,
            userSet: true
        })
        console.log(this.state)
    }

    handleGeoChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value,
        })
        //console.log(this.state)
    }




    loadVendorsData = (id) => {
        let data = db.collection("haney-vendors")
            .get().then((snapshot) => {
                //console.log(snapshot)
                const data = []
                // Parse data into array like in firebase.js
                snapshot.forEach((doc) => {
                    var docData = doc.data()
                    var docObj = {
                        name: docData.name,
                        id: doc.id,
                    }
                    data.push(docObj);
                })
                return (data)
            }, (error) => {
                console.log('error fetching data: ', error)
            }).then(data => {
                data
                this.setState({
                    vendorsData: data,
                    vendorsDataLoaded: true,
                })
            })

        //console.log(this.state)
        //let relatedConceptsData = this.props.relatedConcepts.dataRows

        // this.setState({
        //   relatedConceptsData,
        //   dataLoaded: true
        // })
    }

    loadDriversPickUpData = (id) => {
        let data = db.collection("haney-vendors").doc(id).collection("users").where('userType', '==', 'Driver')
            .get().then((snapshot) => {
                //console.log(snapshot)
                const data = []
                // Parse data into array like in firebase.js
                snapshot.forEach((doc) => {
                    var docData = doc.data()
                    var docObj = {
                        name: docData.name,
                        id: doc.id,
                    }
                    data.push(docObj);
                })
                return (data)
            }, (error) => {
                console.log('error fetching data: ', error)
            }).then(data => {
                //console.log(data)
                this.setState({
                    driversPickUpData: data,
                    driversPickUpDataLoaded: true,
                })
            })

        //console.log(this.state)
        //let relatedConceptsData = this.props.relatedConcepts.dataRows

        // this.setState({
        //   relatedConceptsData,
        //   dataLoaded: true
        // })
    }

    loadDriversDropOffData = (id) => {
        let data = db.collection("haney-vendors").doc(id).collection("users").where('userType', '==', 'Driver')
            .get().then((snapshot) => {
                //console.log(snapshot)
                const data = []
                // Parse data into array like in firebase.js
                snapshot.forEach((doc) => {
                    var docData = doc.data()
                    var docObj = {
                        name: docData.name,
                        id: doc.id,
                    }
                    data.push(docObj);
                })
                return (data)
            }, (error) => {
                console.log('error fetching data: ', error)
            }).then(data => {
                data
                this.setState({
                    driversDropOffData: data,
                    driversDropOffDataLoaded: true,
                })
            })

        //console.log(this.state)
        //let relatedConceptsData = this.props.relatedConcepts.dataRows

        // this.setState({
        //   relatedConceptsData,
        //   dataLoaded: true
        // })
    }

    loadOrderUserData = (id) => {
        console.log("loading order user data")
        let data = db.collection("TEST-users").doc(this.state.orderData.uid)
            .get().then((snapshot) => {
                var docData = snapshot.data()
                if (docData) {
                    var docObj = {
                        ...docData,
                        id: snapshot.id,
                    }
                    return (docObj)
                } else {
                    return (null)
                }
            }, (error) => {
                console.log('error fetching data: ', error)
            }).then(docObj => {
                this.setState({
                    orderUserData: docObj,
                    orderUserDataLoaded: true
                })
            }).then(docObj => {
                if (this.state.orderData.shipperID) {
                    let data = db.collection("haney-shippers").doc(this.state.orderData.shipperID)
                        .get().then((snapshot) => {
                            var docData = snapshot.data()
                            if (docData) {
                                var docObj = {
                                    ...docData,
                                    id: snapshot.id,
                                }
                                return (docObj)
                            } else {
                                return (null)
                            }
                        }, (error) => {
                            console.log('error fetching data: ', error)
                        }).then(docObj => {
                            this.setState({
                                shipperData: docObj,
                                shipperDataLoaded: true
                            })
                        })
                }

            })
        //console.log(this.state)
        //let relatedConceptsData = this.props.relatedConcepts.dataRows

        // this.setState({
        //   relatedConceptsData,
        //   dataLoaded: true
        // })
    }




    loadOrdersData = (id) => {
        console.log("loading order data")
        let data = db.collection("haney-orders").doc(id)
            .get().then((snapshot) => {
                var docData = snapshot.data()
                if (docData) {
                    var docObj = {
                        ...docData,
                        id: snapshot.id,
                    }
                    return (docObj)
                } else {
                    return (null)
                }
            }, (error) => {
                console.log('error fetching data: ', error)
            }).then(docObj => {
                this.setState({
                    orderData: docObj,
                    orderDataLoaded: true
                })
            })
        //console.log(this.state)
        //let relatedConceptsData = this.props.relatedConcepts.dataRows

        // this.setState({
        //   relatedConceptsData,
        //   dataLoaded: true
        // })
    }

    loadShipperData = () => {
        console.log("loading order data")
        if (this.state.orderData.shipperID) {
            let data = db.collection("haney-shippers").doc(this.state.orderData.shipperID)
                .get().then((snapshot) => {
                    var docData = snapshot.data()
                    if (docData) {
                        var docObj = {
                            ...docData,
                            id: snapshot.id,
                        }
                        return (docObj)
                    } else {
                        return (null)
                    }
                }, (error) => {
                    console.log('error fetching data: ', error)
                }).then(docObj => {
                    this.setState({
                        shipperData: docObj,
                        shipperDataLoaded: true
                    })
                })
        }

        //console.log(this.state)
        //let relatedConceptsData = this.props.relatedConcepts.dataRows

        // this.setState({
        //   relatedConceptsData,
        //   dataLoaded: true
        // })
    }

    loadPickUpDriverContact = (id) => {
        console.log("loading order data")
        let data = db.collection("TEST-users").doc(id)
            .get().then((snapshot) => {
                var docData = snapshot.data()
                if (docData) {
                    var docObj = {
                        ...docData,
                        id: snapshot.id,
                    }
                    return (docObj)
                } else {
                    return (null)
                }
            }, (error) => {
                console.log('error fetching data: ', error)
            }).then(docObj => {
                this.setState({
                    pickUpDriverContact: docObj,
                    pickUpDriverContactLoaded: true
                })
            })
        //console.log(this.state)
        //let relatedConceptsData = this.props.relatedConcepts.dataRows

        // this.setState({
        //   relatedConceptsData,
        //   dataLoaded: true
        // })
    }

    selectFlight = (flight) => {
        console.log("selecting flight")
        console.log(flight)

        const { airlineName, originAirport, destinationAirport } = flight;
        console.log("airlineName")
        console.log(airlineName, originAirport, destinationAirport);
        if (!airlineName) {
            console.log("No airline name given");
            db.collection('haney-orders').doc(this.props.orderID).set({
                flight: flight
            }, { merge: true });
            return this.setState({ flight: flight });
        }

        const airlineRef = db.collection("haney-vendors").where('name', '==', airlineName);

        Promise.all([
            airlineRef.where('airCodes', 'array-contains', originAirport).get(),
            airlineRef.where('airCodes', 'array-contains', destinationAirport).get()
        ])
            .then(responses => {
                const [originAirlinesSnapshot, destinationAirlinesSnapshot] = responses;
                console.log(responses);
                const loopLen = Math.max(originAirlinesSnapshot.docs.length, destinationAirlinesSnapshot.docs.length);

                const [originAirlineDetails, destinationAirlineDetails] = [[], []];
                for (let i = 0; i < loopLen; i++) {
                    if (originAirlinesSnapshot.docs.length > i) {
                        const oAirline = {
                            ...originAirlinesSnapshot.docs[i].data(),
                            id: originAirlinesSnapshot.docs[i].id
                        }

                        originAirlineDetails.push(oAirline);
                    }
                    if (destinationAirlinesSnapshot.docs.length > i) {
                        const dAirline = {
                            ...destinationAirlinesSnapshot.docs[i].data(),
                            id: destinationAirlinesSnapshot.docs[i].id
                        }

                        destinationAirlineDetails.push(dAirline);
                    }
                }

                const addressedOriginVendor = originAirlineDetails.find(obj => obj.physicalAddress);
                const addressedDestinationVendor = destinationAirlineDetails.find(obj => obj.physicalAddress);

                if (addressedOriginVendor) flight.originAirlineAddress = addressedOriginVendor.physicalAddress;
                if (addressedDestinationVendor) flight.destinationAirlineAddress = addressedDestinationVendor.physicalAddress;

                this.setState({
                    originAirlineDetails: originAirlineDetails,
                    destinationAirlineDetails: this.state.additionalLegs ? ((this.state.additionalLegs[0].originAirport == destinationAirlineDetails[0].airCodes) ? this.state.destinationAirlineDetails : destinationAirlineDetails) : destinationAirlineDetails,
                    airportAddressUpdated: true,
                    flight: flight,
                    flightFlights: []
                })

                db.collection('haney-orders').doc(this.props.orderID).set({
                    originAirlineDetails: originAirlineDetails,
                    destinationAirlineDetails: this.state.additionalLegs ? ((this.state.additionalLegs[0].originAirport == destinationAirlineDetails[0].airCodes) ? this.state.destinationAirlineDetails : destinationAirlineDetails) : destinationAirlineDetails,
                    flight: flight
                }, { merge: true });

            })
    }

    selectAdditionalLegs = (flight) => {
        console.log("selecting flight")
        console.log(flight)

        const { airlineName, originAirport, destinationAirport } = flight;
        console.log("airlineName")
        console.log(airlineName, originAirport, destinationAirport);
        if (!airlineName) {
            console.log("No airline name given");
            db.collection('haney-orders').doc(this.props.orderID).set({
                additionalLegs: [flight]
            }, { merge: true });
            return this.setState({
                additionalLegs: [flight]
            });
        }
        const airlineRef = db.collection("haney-vendors").where('name', '==', airlineName);

        Promise.all([
            airlineRef.where('airCodes', 'array-contains', destinationAirport).get()
        ])
            .then(responses => {
                const [destinationAirlinesSnapshot] = responses;
                console.log(responses);
                const loopLen = Math.max(destinationAirlinesSnapshot.docs.length);

                const [destinationAirlineDetails] = [[], []];
                for (let i = 0; i < loopLen; i++) {

                    if (destinationAirlinesSnapshot.docs.length > i) {
                        const dAirline = {
                            ...destinationAirlinesSnapshot.docs[i].data(),
                            id: destinationAirlinesSnapshot.docs[i].id
                        }

                        destinationAirlineDetails.push(dAirline);
                    }
                }

                const addressedDestinationVendor = destinationAirlineDetails.find(obj => obj.physicalAddress);

                if (addressedDestinationVendor) flight.destinationAirlineAddress = addressedDestinationVendor.physicalAddress;

                this.setState({
                    destinationAirlineDetails: destinationAirlineDetails,
                    airportAddressUpdated: true,
                    additionalLegs: [flight]
                })
                db.collection('haney-orders').doc(this.props.orderID).set({
                    destinationAirlineDetails: destinationAirlineDetails,
                    additionalLegs: [flight]
                }, { merge: true });

            })
    }

    openChat = (c) => {
        const chatsOpen = this.state.openChats;
        const index = chatsOpen.indexOf(c);
        if (index > -1) {
            chatsOpen.splice(index, 1);
        } else {
            chatsOpen.splice(chatsOpen.length, 0, c);
        }
        this.setState({ openChats: chatsOpen })
    }



    render() {
        const { classes, modalClose, orderID, authUser, user } = this.props;

        let search = window.location.search
        let searchArr = search.split('&')

if (this.state.orderDataLoaded) {
    let qbObj =  {
        qbAuthCode: window.location.href,
        authCode: searchArr[0].substring(6),
        realmID: searchArr[2].substring(8)
    }
    console.log(qbObj)
    console.log(this.state.orderData.docs.invoice.id)
    db.collection("haney-orders").doc(this.state.orderData.id).collection("invoices").doc(this.state.orderData.docs.invoice.id).set({
        ...qbObj
    }, { merge: true }).then(() => {
        this.setState({ redirect: true })
    })

}
       
        console.log(this.state)


        if (user.dataLoaded
            && !this.state.orderDataLoaded && !this.state.vendorsDataLoaded && this.state.orderID) {
            this.loadOrdersData(this.state.orderID)
            this.loadVendorsData()
        }


        if (!this.state.redirect) {

        return (
            <div>
               hello
            </div>
        );
        } else {
            return (
                <Redirect to={`/order/${this.state.orderID}`} />
              );  
        }
    }
}

Form.propTypes = {
    classes: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
    //console.log(state)
    return {
        AuthBool: !!state.auth.user,
        authUser: state.auth.user,
        user: state.profile.user,
    }
}

export default compose(
    connect(mapStateToProps),
    withStyles(styles)
)(Form);


// WEBPACK FOOTER //
// ./src/views/Orders/QB.jsx